module.exports = __webpack_public_path__ + "img/clone.05a0b2a6.svg";